module.exports = "/_next/static/images/ourPartnersLogo15-a7e395ad69e86e00b5b089f05eef024f.webp";